import { createAppSlice } from 'app/createAppSlice'
import { getComodities } from './projectsAction'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: undefined,
    status: undefined,
    from: undefined,
    to: undefined,
    workerUserIds: undefined,
    targetIds: undefined,
    goal: undefined,
    goalMin: undefined,
    goalMax: undefined,
    completion: undefined,
    completionMin: undefined,
    completionMax: undefined,
    completion_progress: undefined,
  },
  tagShared: {
    size: 10,
    page: 0,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: undefined,
    status: undefined,
    from: undefined,
    to: undefined,
    workerUserIds: undefined,
    targetIds: undefined,
    goal: undefined,
    goalMin: undefined,
    goalMax: undefined,
    completion: undefined,
    completionMin: undefined,
    completionMax: undefined,
    completion_progress: undefined,
  },
  tagSchema: {
    size: 10,
    page: 0,
    sortby: 'createdAt',
    sortdir: 'DESC',
    s: undefined,
    status: undefined,
  },
  loading: false,
  comodities: [],
  isOpenModalSchema: false,
}

export const projectsMenuListSlice = createAppSlice({
  name: 'projectsMenuList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setFetchOptionShared: create.reducer((state, { payload }) => {
      state.tagShared = { ...state.tagShared, ...payload }
    }),
    setFetchOptionSchema: create.reducer((state, { payload }) => {
      state.tagSchema = { ...state.tagSchema, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
    toggleModalSchema: create.reducer((state) => {
      state.isOpenModalSchema = !state.isOpenModalSchema
    }),
  }),
  extraReducers: (builder) => {
    builder.addCase(getComodities.fulfilled, (state, { payload }) => {
      state.comodities = payload
      state.loading = false
    })
    builder.addCase(getComodities.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getComodities.rejected, (state) => {
      state.loading = false
    })
  },
})

export const {
  setFetchOption,
  setFetchOptionShared,
  setFetchOptionSchema,
  setLoading,
  toggleModalSchema,
} = projectsMenuListSlice.actions

export default projectsMenuListSlice.reducer
